import axios from 'axios';
import { URL } from '../url/api';
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: URL,
});

api.interceptors.request.use((config) => {
  let token = localStorage.getItem('user_session');
  if(!token){
    token = Cookies.get("user_session");
  }
  if (token) {
    localStorage.setItem("user_session", token);
    config.headers.Authorization = `Bearer ${token.replace(/"/g, '')}`;
  }
  return config;
});

export default api;
